import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";

import type { ContractContactsApiResponse } from "../types";

import { paramsSerializer } from "../utils/params-serializer";

import { CONTRACT_CONTACTS_ENDPOINT, CONTRACT_CONTACTS_PER_PAGE } from "./endpoints";
import { contractContactsQueryKey } from "./query-keys";

/**
 * Lists the contract's alert subscriptions from `GET /contract-contacts`.
 * Ordered by contact so a contact's alert types arrive together, and fetched in
 * one page so a contact's rows can be grouped client-side (see
 * `contractContactGroups`). The attached contact is eager-loaded by the
 * backend, so no `include` is needed.
 */
export const useContractContactsService = (contractId: string | number | undefined) =>
  useQuery<ContractContactsApiResponse>({
    queryKey: contractContactsQueryKey(String(contractId ?? "")),
    queryFn: async () => {
      const res = await axiosInstance().get<ContractContactsApiResponse>(CONTRACT_CONTACTS_ENDPOINT, {
        params: {
          sort: "contact_id",
          per_page: CONTRACT_CONTACTS_PER_PAGE,
          contract_id: contractId,
        },
        paramsSerializer,
      });

      return res.data;
    },
    enabled: Boolean(contractId),
    retry: false,
    refetchOnWindowFocus: false,
  });
